import React, { useMemo } from 'react';
import { Autocomplete, Stack, TextField, Typography } from '@mui/material';
import { useGetLegalTransactions } from '../../hooks/data';

/**
 * Der Vorgang, mit dem der Editor seine Vorschauwerte zeigt (#1245).
 *
 * Ohne ihn ist eine Feldauswahl eine Liste von Namen; mit ihm steht neben jedem Feld, was
 * später im Dokument stünde. Er ändert nichts am Baum — er ist nur die Brille, durch die man
 * ihn ansieht.
 */
interface Props {
  value: number | null;
  onChange: (_value: number | null) => void;
}

export const PreviewTransactionPicker: React.FC<Props> = ({
  value,
  onChange,
}) => {
  const { legalTransactions, isLoadingLegalTransactions } =
    useGetLegalTransactions();

  const options = useMemo(
    () =>
      (legalTransactions ?? []).map(
        (item: { idLegalTransaction: number; Title?: string | null }) => ({
          id: item.idLegalTransaction,
          label: `#${item.idLegalTransaction} ${item.Title ?? ''}`.trim(),
        })
      ),
    [legalTransactions]
  );

  const selected = options.find(option => option.id === value) ?? null;

  return (
    <Stack spacing={0.25} sx={{ minWidth: 300 }}>
      <Typography variant='caption' color='text.secondary'>
        Vorschau mit Vorgang
      </Typography>
      <Autocomplete
        options={options}
        value={selected}
        loading={isLoadingLegalTransactions}
        size='small'
        onChange={(_event, next) => onChange(next?.id ?? null)}
        isOptionEqualToValue={(option, current) => option.id === current.id}
        renderInput={parameters => (
          <TextField
            {...parameters}
            placeholder='Kein Vorgang gewählt'
            aria-label='Vorgang für die Vorschau'
          />
        )}
      />
    </Stack>
  );
};
